import { SEARCH_VARIANT } from 'constants/Shared';

const ACTION_TYPES = {
    FOCUS_SEARCH_BAR: 'FOCUS_SEARCH_BAR',
    HIDE_SEARCH_RESULTS: 'HIDE_SEARCH_RESULTS',
    SHOW_SEARCH_RESULTS: 'SHOW_SEARCH_RESULTS',
    SHOW_ZERO_STATE_RESULTS: 'SHOW_ZERO_STATE_SEARCH_RESULTS'
};

const initialState = {
    [SEARCH_VARIANT.SITE]: {
        focus: false,
        keyword: null
    },
    [SEARCH_VARIANT.SYS]: {
        focus: false,
        keyword: null
    }
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SHOW_ZERO_STATE_RESULTS:
            return Object.assign({}, state, {
                [action.variant]: {
                    results: action.results,
                    focus: true
                }
            });
        case ACTION_TYPES.HIDE_SEARCH_RESULTS: {
            return Object.assign({}, state, { [action.variant]: { focus: false } });
        }
        case ACTION_TYPES.SHOW_SEARCH_RESULTS:
            return Object.assign({}, state, {
                [action.variant]: {
                    results: action.results,
                    keyword: action.keyword,
                    focus: true
                }
            });

        case ACTION_TYPES.FOCUS_SEARCH_BAR: {
            const nextState = {
                ...state,
                [action.variant]: {
                    ...state[action.variant],
                    focus: action.focus
                }
            };

            return nextState;
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
